'use strict';

/* globals $, window, document */

require(['chatCustoms', 'chatFileUpload', 'userActivity'], function (chatCustoms, chatFileUpload, userActivity) {
	var customChatPage = {};

	chatCustoms.onChatLoaded();

	$(window).on('action:ajaxify.end', function (event, data) {
		userActivity.init(data);

		customChatPage.removeTaskbar(data);
		chatCustoms.receivedChatMessage(data);
	});

	$(document).ready(function () {
		userActivity.init();

		// if (utils.isMobile()) {
		// 	refreshChatPage();
		// }
	});

	// function refreshChatPage() {
	// 	document.addEventListener('visibilitychange', function () {
	// 		if (!$('.chats-container').length || $('body').data('isUploading')) {
	// 			return;
	// 		}

	// 		var prevType = $(this).data('prevType');

	// 		if (prevType !== document.visibilityState && document.visibilityState === 'visible') {
	// 			chatCustoms.reloadChat();
	// 		}

	// 		$(this).data('prevType', document.visibilityState);
	// 	});
	// }

	customChatPage.removeTaskbar = function (data) {
		$('#taskbar').css('display', data.tpl_url === 'chats' && $(window).width() < 1000 ? 'none' : 'block');
	};
});
